import React, { createContext, useContext, useState, useEffect } from 'react';
import translations from '../i18n/translations';
import { useAuth } from './AuthContext';

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const { user } = useAuth();
  const [language, setLanguage] = useState('fr');

  // Sync language with user preference
  useEffect(() => {
    if (user?.language) {
      setLanguage(user.language);
    }
  }, [user]);

  // Translation function
  const t = (key) => {
    const translation = translations[language]?.[key];
    if (!translation) {
      // Fallback to French, then to key
      return translations['fr']?.[key] || key;
    }
    return translation;
  };

  // Get all available languages
  const availableLanguages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
  ];

  // Update language (will be synced with backend)
  const changeLanguage = (newLang) => {
    if (translations[newLang]) {
      setLanguage(newLang);
    }
  };

  return (
    <I18nContext.Provider value={{ 
      language, 
      setLanguage: changeLanguage, 
      t, 
      availableLanguages 
    }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};
